import gql from 'graphql-tag';

import dokkioThreadFragment from '../fragments/dokkioThreadFragment';

export const mutationUpdateDokkioThread = gql`
  mutation updateDokkioThread(
    $id: DokkioID!
    $dokkioTagIDs: [DokkioID!]
  ) {
    updateDokkioThread(
      id: $id
      dokkioTagIDs: $dokkioTagIDs
    ) {
      ...dokkioThreadFragment
    }
  }
  ${dokkioThreadFragment}
`;
export default mutationUpdateDokkioThread;
